import Menu from 'element-ui/lib/menu'
import MenuWrapper from './menu-wrapper'

import { select, hasProp } from 'vessel/utils'

export default {
  name: 'VsMenuBuilder',
  props: {
    ...MenuWrapper.props,
    noAuthStyle: {
      type: String,
      default: 'hidden'
    },
    auth: {
      type: String,
      default: ''
    },
    activeIndex: {
      type: String,
      default: null
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  render(h) {
    return this.renderMenu(h, MenuWrapper, this.items, {
      attrs: this.$attrs,
      props: this.menuProps,
      ref: 'menuBuilder',
      on: this.$listeners
    })
  },
  mounted() {
    this.$nextTick(() => {
      Object.keys(Menu.methods).forEach((item) => {
        this[item] = this.$refs.menuBuilder[item]
      })
    })
  },
  watch: {
    activeIndex(value) {
      this.$nextTick(() => {
        this.$refs.menuBuilder.activeIndex = value
      })
    }
  },
  computed: {
    menuProps() {
      return select(this.$props, key => hasProp(key, Menu.props))
    }
  },
  methods: {
    renderMenuItem(h, { href, ...item }, id) {
      const icon = item.icon ? h('vs-icon', { props: { name: item.icon } }) : null
      const label = h('span', item.label)

      if (href && href.startsWith('http')) {
        const link = h('vs-link', { props: { href } }, [icon, label])
        return h('vs-menu-item', {}, [link])
      } else {
        const props = { ...item, href, index: item.value || id }
        return h('vs-menu-item', { props }, [icon, label])
      }
    },
    renderMenuItemGroup(h, item, id) {
      const props = { title: item.title }

      return this.renderMenu(h, 'vs-menu-item-group', item.content, { props }, id)
    },
    renderSubMenu(h, item, id) {
      const icon = item.icon ? h('vs-icon', { props: { name: item.icon } }) : null
      const label = h('span', item.label)
      const title = h('template', { slot: 'title' }, [icon, label])
      const props = { ...item, index: item.value || id }

      return this.renderMenu(h, 'vs-submenu', item.children, { props }, id, title)
    },
    renderMenu(h, tag, menuData, options = {}, id = null, before = null, after = null) {
      const menuItems = menuData.reduce((acc, itm, idx) => {
        const item = { ...itm }

        if (item.visible === false) {
          return acc
        }

        if (Array.isArray(item.auth) && !item.auth.includes(this.auth)) {
          if (this.noAuthStyle === 'disabled')
            item.disabled = true
          else
            return acc
        }

        const newId = id ? `${id}-${idx + 1}` : `${idx + 1}`

        if (item.children)
          acc.push(this.renderSubMenu(h, item, newId))
        else if (item.content)
          acc.push(this.renderMenuItemGroup(h, item, newId))
        else
          acc.push(this.renderMenuItem(h, item, newId))

        return acc
      }, [])

      return h(tag, options, [before, ...menuItems, after])
    }
  }
}
